export class GetTransactionDetailRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  categoryCode: string | null = null;
  merchantCode: string | null = null;
  providerCode: string | null = null;
  productCode: string | null = null;
  // type: string = '1'; // value 1 is transactionDetail type
  status: string | null = null;
  createdFrom: string | null = null;
  createdTo: string | null = null;
}

export class CreateTransactionDetailParams {
  id: string = '';
  name: string = '';
  user: string = '';
  password: string = '';
  secret_code: string = '';
  base_url: string = '';
  method: string = '';
  inq_param: string = '';
  pay_param: string = '';
  adv_param: string = '';
  reversal_param: string = '';
  inq_url: string = '';
  pay_url: string = '';
  adv_url: string = '';
  reversal_url: string = '';
  status: string | null = null;
  productCode: string | null = null;
}

export class UpdateTransactionDetailRequestParams extends CreateTransactionDetailParams {
  oldPassword?: string;
}

export interface TransactionDetailData {
  id: string;
  name: string;
  user: string;
  password: string;
  secret_code: string;
  base_url: string;
  method: string;
  inq_param: string;
  pay_param: string;
  adv_param: string;
  reversal_param: string;
  inq_url: string;
  pay_url: string;
  adv_url: string;
  reversal_url: string;
  created_at: string;
  updated_at: string;
}

export interface GetTransactionDetailResponse {
  code: number;
  message: string;
  data: TransactionDetailData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetTransactionDetailByIdResponse {
  code: number;
  message: string;
  data: TransactionDetailData;
}

export interface DeleteTransactionDetailByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
